import {
  Box,
  Container,
  Typography,
  Grid,
  useMediaQuery,
  Icon,
} from "@mui/material";
import React, { useState } from "react";
import { icons, images } from "../../assets";
import { allColors } from "../../constants";
import GlobalButton from "../../components/globalButton";
import { useNavigate } from "react-router-dom";

const sectionData = [
  {
    id: 1,
    title: "Fibre & Phone",
    price: "£41.99",
    bgColor: "linear-gradient(to right, #f99557, #fda974)",
    rightImg: images.routerPhoneImg,
    options: [
      {
        id: 1,
        image: icons.circleinfinityIcon,
        icon: "all_inclusive",
        title: "Unlimited UK landline & mobile calls",
      },
      {
        id: 2,
        image: icons.circlePowerIcon,
        icon: "bolt",
        title: "Download speed up to 40 Mbps",
      },
      {
        id: 3,
        image: icons.circleWorldIcon,
        icon: "language",
        title: "Unlimited internet",
      },
      {
        id: 3,
        image: icons.circleCheckBlackIcon,
        icon: "check",
        title: "Free router & handset",
      },
    ],
    showMore: false,
  },
  {
    id: 2,
    title: "Superfast Fibre & Phone",
    price: "£44.99",
    bgColor: "linear-gradient(to right, #fda974, #fae3c7)",
    rightImg: images.routerSilverPhoneImg,
    options: [
      {
        id: 1,
        image: icons.circleinfinityIcon,
        icon: "all_inclusive",
        title: "Unlimited UK landline & mobile calls",
      },
      {
        id: 2,
        image: icons.circlePowerIcon,
        icon: "bolt",
        title: "Download speed up to 80 Mbps",
      },
      {
        id: 3,
        image: icons.circleWorldIcon,
        icon: "language",
        title: "Unlimited internet",
      },
      {
        id: 3,
        image: icons.circleCheckBlackIcon,
        icon: "check",
        title: "Free router & handset",
      },
    ],
    showMore: false,
  },
];

const PhoneBroadbandSection = () => {
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [broadbandData, setBroadbandData] = useState(sectionData);

  const handleShowMore = (inddddd) => {
    let tempArrr = [...broadbandData];
    tempArrr[inddddd].showMore = !tempArrr[inddddd].showMore;
    setBroadbandData(tempArrr);
  };

  return (
    <Container
      sx={{
        maxWidth: "1250px !important",
        textAlign: "center",
        marginTop: "30px",
        paddingBottom: "50px",
      }}
      id="phone-broadband"
    >
      <Typography
        sx={{
          textAlign: "center",
          fontSize: { xs: "22px", sm: "35px", md: "50px" },
          color: allColors.jetBlack,
          fontWeight: "400",
          marginBottom: "30px",
          fontFamily: "Raleway",
        }}
      >
        Phone & Broadband
      </Typography>

      <Grid container spacing={3} justifyContent={"space-between"}>
        {broadbandData.map((itemmmm, inddd) => {
          return (
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  background: itemmmm.bgColor,
                  padding: {
                    xs: "15px 24px 24px 18px",
                    sm: "15px 24px 24px 44px",
                  },
                  borderRadius: "20px",
                  position: "relative",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: { xs: "center", sm: "space-between" },
                  }}
                >
                  <Box
                    sx={{
                      background: allColors.jasmine,
                      borderRadius: { xs: "20px", sm: "10px" },
                      padding: "5px",
                      // display: { xs: "block", sm: "none" },
                      textAlign: "center",
                      width: {
                        xs: inddd == 0 ? "55%" : "82%",
                        md: inddd == 0 ? "40%" : "65%",
                      },
                      margin: {
                        xs: "10px auto 12px",
                        sm: "10px auto 12px 0",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Raleway",
                        fontSize: { xs: "20px", md: "28px" },
                        color: allColors.jetBlack,
                        fontWeight: "400",
                      }}
                    >
                      {itemmmm.title}{" "}
                    </Typography>
                  </Box>
                  {inddd == 0 && (
                    <Box
                      sx={{
                        background: allColors.blueBerry,
                        borderRadius: "50%",
                        width: "90px",
                        height: "90px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "10px",
                        position: "absolute",
                        right: 20,
                        top: 16,
                        display: { xs: "none", sm: "flex" },
                      }}
                    >
                      <Typography
                        sx={{
                          color: allColors.jetBlack,
                          fontSize: "12px",
                          fontWeight: "600",
                          lineHeight: "16px",
                        }}
                      >
                        Broadband speed subject to your area
                      </Typography>
                    </Box>
                  )}
                </Box>

                <Grid
                  container
                  spacing={3}
                  sx={{ position: "relative" }}
                  alignItems={{ xs: "center", sm: "flex-end" }}
                >
                  <Grid item xs={6.5} sm={6}>
                    <Typography
                      sx={{
                        fontFamily: "Squad-Regular",
                        fontSize: { xs: "40px", md: "50px" },
                        color: allColors.jetBlack,
                        fontWeight: "700",
                        textAlign: "left",
                        marginTop: "10px",
                        marginLeft: { xs: "20px", sm: 0 },
                      }}
                    >
                      {itemmmm.price}
                      <span
                        style={{
                          fontSize: isSmallScreen ? "10px" : "14px",
                        }}
                      >
                        p/m
                      </span>
                    </Typography>

                    {itemmmm.options.map((optiionn) => {
                      return (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "10px",
                            marginLeft: { xs: "5px", sm: 0 },
                          }}
                        >
                          {/* <img
                            src={optiionn.image}
                            alt={optiionn.image}
                            style={{
                              width: "45px",
                              height: "45px",
                              marginRight: "10px",
                            }}
                          /> */}
                          <Box
                            sx={{
                              background: allColors.jetBlack,
                              borderRadius: "50%",
                              padding: { xs: "5px", sm: "10px" },
                              marginRight: "10px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Icon
                              sx={{ color: inddd == 0 ? "#f99557" : "#fda974" }}
                            >
                              {optiionn.icon}
                            </Icon>
                          </Box>
                          <Typography
                            sx={{
                              fontSize: { xs: "12px", sm: "14px" },
                              color: allColors.jetBlack,
                              fontWeight: "400",
                              textAlign: "left",
                            }}
                          >
                            {optiionn.title}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Grid>
                  <Grid item xs={5.5} sm={6}>
                    <img
                      src={itemmmm.rightImg}
                      style={{
                        width: "100%",
                        height: "100%",
                        marginTop: "40px",
                      }}
                    />
                  </Grid>
                </Grid>

                {itemmmm.showMore && (
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "14px" },
                      color: allColors.jetBlack,
                      fontWeight: "400",
                      textAlign: "center",
                      margin: "20px 0",
                    }}
                  >
                    VAT excluded from price. Contract length of 18, 24 or 36
                    months. <span style={{ fontWeight: "700" }}>Broadband</span>
                    : Download speed of up to{" "}
                    {inddd == 0 ? "40 Mbps" : "80 Mbps"}. Upload speed of up to{" "}
                    {inddd == 0 ? "10 Mbps" : "20 Mbps"}. Speeds dependent on
                    availability. Tariff upgrade may be required. £30 router
                    configuration and delivery cost applies. <br />{" "}
                    <span style={{ fontWeight: "700" }}>Phone</span>: £60
                    digital installation upgrade fees may apply. Handset free of
                    charge. £30 handset delivery charge applies.{" "}
                    <span
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                      onClick={() => navigate("/voip-terms-&-conditions")}
                    >
                      Full T&Cs
                    </span>
                    .
                  </Typography>
                )}
              </Box>

              <Box
                sx={{
                  position: "relative",
                  marginTop: "-22px",
                }}
              >
                {!itemmmm.showMore ? (
                  <GlobalButton
                    handleClickBtn={() => handleShowMore(inddd)}
                    title={"Show more"}
                    style={{
                      background: allColors.white,
                      color: allColors.jetBlack,
                      border: `1px solid ${allColors.pastelGray}`,
                      borderRadius: "10px",
                      fontSize: "12px",
                      padding: { xs: "10px 40px", sm: "10px 20px" },
                    }}
                  />
                ) : (
                  <a href={"#contact-us"}>
                    <GlobalButton
                      handleClickBtn={() => handleShowMore(inddd)}
                      title={"Switch today"}
                      style={{
                        background: allColors.blueCrayola,
                        color: allColors.white,
                        border: `1px solid ${allColors.blueCrayola}`,
                        borderRadius: "10px",
                        fontSize: "12px",
                        padding: { xs: "10px 40px", sm: "10px 20px" },
                      }}
                    />
                  </a>
                )}
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

export default PhoneBroadbandSection;
